import {history} from '../../../history'
import {store} from '../../utilities'

export default function onRow(record, setListFilters) {
  return {
    style: {cursor: `pointer`},
    onClick: (e) => {
      if (e.metaKey) return window.open(`/tickets/${record.id}`)
      const state = store.getState()
      if (setListFilters) {
        setListFilters((prevFilters) => ({
          ...prevFilters,
          type: "projects", 
          query : { 
            status : state?.query?.status || null,
            fullTextQuery: state?.query?.fullTextQuery || null,
            filters: state?.query?.filters || null,
            from: state?.query?.from || 0
          }, // Resetting the filter
          tableControls: {
            sorter: state?.tableControls?.sorter || null,
            pagination: state?.tableControls?.pagination || null
          }
        }))
      }
      history.push(`/tickets/${record.id}`)
    },
  }
}
